// extracted by css-extract-rspack-plugin
export default {"cls1":"claim_ticket-cls1_VVK","cls2":"claim_ticket-cls2_2sP claim_ticket-cls1_VVK"};